/**
 * nodeBusy — puente entre el store/hooks y el mini-modal de "nodo ocupado".
 *
 * El store no puede renderizar UI, así que publica el pedido acá y espera la
 * respuesta del usuario: 'send' (mandar otra), 'stop_and_send' (detener las
 * anteriores y mandar) o 'cancel' (no hacer nada).
 */
let resolver = null;
let listener = null;

/** Lo usa NodeBusyConfirmDialog para recibir los pedidos. */
export const onNodeBusyRequest = (fn) => {
  listener = fn;
  return () => { if (listener === fn) listener = null; };
};

/**
 * Pide confirmación. `request`:
 *   { nodes: [{ nodeId, label, running }], cost, source }
 * Devuelve 'send' | 'stop_and_send' | 'cancel'.
 */
export const askNodeBusy = (request) => {
  if (!listener) return Promise.resolve('send'); // sin UI montada: no bloquear
  return new Promise((resolve) => {
    resolver = resolve;
    listener(request);
  });
};

/** Lo llama el modal con la decisión del usuario. */
export const answerNodeBusy = (answer) => {
  const fn = resolver;
  resolver = null;
  if (fn) fn(answer);
};

export const BUSY_TEXT = (running, cost) => {
  const plural = running === 1 ? 'generación' : 'generaciones';
  const costo = cost ? ` por ${cost} cr` : '';
  return `Este nodo ya tiene ${running} ${plural} en curso.\n`
    + `¿Mandar otra${costo}? La anterior va a quedar en la galería.`;
};
